<script setup lang="ts">
import {FormKit} from "@formkit/vue"
import {Field_Checkboxes, FieldInterface} from "../../../../gql/types/types";
import CustomCheckbox from "./includes/CustomCheckbox.vue";
import { VServices } from "@libVue/base";
import { TranslationService } from "../../../../services/translation.service";

const SERVICES = VServices({translation:TranslationService})

const {field} = defineProps({
  field: {
    type: Object as () => Field_Checkboxes,
    required: true
  },
  formValues:{
    type:Object,
    required:true
  }
})

const t = (key: string) => {
  return SERVICES.translation.t(key)
}


</script>

<template>
<FormKit type="checkbox" :id="`field:${field.handle}`" :validation="field.required ? 'min:1|required': '' " :options="field.options" :name="field.handle" :label="field.label" label-class="ml-2" :outer-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput' ? 'grid grid-cols-2 gap-6 justify-between !mb-0': '' " :fieldset-class="field.labelPosition == 'verbb\\formie\\positions\\LeftInput'? 'contents': ''" :help="field.instructions">
  <template #decorator>
    <custom-checkbox />
  </template>
</FormKit>
</template>

<style scoped lang="scss">

</style>